import type BaseLayer from "ol/layer/Base";

/**
 * 레이어 속성 키 — 참이면 이슈 선택·호버 커서의 피처 판정에서 그 레이어를 건너뛴다. 장비 반경처럼
 * 넓은 면을 그리는 **보기 전용** 레이어에 단다. 없으면 그 면 안의 빈 곳을 눌러도 그 도형이 선택된다.
 *
 * @example new VectorLayer({ properties: { [EXCLUDE_FROM_SELECTION]: true } })
 */
export const EXCLUDE_FROM_SELECTION = "excludeFromSelection";

export const isSelectableLayer = (layer: BaseLayer) =>
  layer.get(EXCLUDE_FROM_SELECTION) !== true;
